import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_es.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.es.js'
import 'moment/locale/es.js'
import './translations.tc.es.js'

$.fn.datepicker.defaults.language = 'es'

I18n.defaultLocale = 'es'
I18n.locale = 'es'

export default App
